import {
  SET_SEARCH_MODEL,
  SET_PAGINATION_MODEL,
  SET_AUDIT_TABLE_DATA,
  SET_CURRENT_TAB,
  SET_TRADE_TAG_LIST,
  SET_DICTIONARY_DATA,
  SET_TRADE_SEARCH_CUSTOM_LIST,
  SET_TRADE_SETTINGS,
  SET_TRADE_SETTINGS_NEW,
  SET_LIST_GOODSINFO_SETTINGS,
  SET_TRADE_PAGESIZE,
  SET_AUDIT_STATUS_COUNT,
  SET_LIST_KEEP_LAST_RENDER_INDEX,
} from './types';

export default {
  // 设置搜索数据
  [SET_SEARCH_MODEL](state, payload = {}) {
    state.searchModel = {
      ...state.searchModel,
      ...payload,
    };
  },
  // 设置分页数据
  [SET_PAGINATION_MODEL](state, payload = {}) {
    state.paginationModel = {
      ...state.paginationModel,
      ...payload,
    };
  },
  [SET_AUDIT_TABLE_DATA](state, tableData = []) {
    state.auditTableData = tableData;
  },

  [SET_CURRENT_TAB](state, currentTab) {
    state.currentTab = currentTab;
  },
  // 设置标签
  [SET_TRADE_TAG_LIST](state, payload = []) {
    state.tagList = payload;
  },
  // 设置字典数据
  [SET_DICTIONARY_DATA](state, payload = {}) {
    state.dictionaryData = { ...state.dictionaryData, ...payload };
  },
  // 设置字典数据
  setChecksTable(state, checksTable = []) {
    state.checksTable = checksTable;
  },
  [SET_TRADE_SEARCH_CUSTOM_LIST](state, payload = []) {
    state.groupList = payload;
  },
  // 设置交易
  [SET_TRADE_SETTINGS](state, payload = {}) {
    state.tradeSetting = { ...state.tradeSetting, ...payload };
  },
  [SET_TRADE_SETTINGS_NEW](state, payload = {}) {
    state.tradeNewSetting = { ...state.tradeNewSetting, ...payload };
  },
  // 设置列表商品信息展示
  [SET_LIST_GOODSINFO_SETTINGS](state, payload = {}) {
    state.goodsInfoShow = {...payload};
  },
  // 设置pageSize
  [SET_TRADE_PAGESIZE](state, payload = {}) {
    state.pageSizeRemote = {...payload};
  },
  // 审核状态数量统计
  [SET_AUDIT_STATUS_COUNT](state, payload = {}) {
    state.auditStatusCount = { ...state.auditStatusCount, ...payload };
  },
  // 列表加载保留上次渲染索引表示
  [SET_LIST_KEEP_LAST_RENDER_INDEX](state, payload = false) {
    state.listKeepLastRenderIndex = payload;
  },
};
